import { ISliderValueDisp } from "./interfaces/ISliderValueDisp";
import { AValueComponent } from "./AValueComponent";
import { ValueChangerController } from "./ValueChangerController";

import MouseEvent = createjs.MouseEvent;

export class SliderValueComponent extends AValueComponent {
    private sliderContainer: ISliderValueDisp;
    private _barOffset: number;
    private _barSize: number;
    private sliding: boolean = false;
    private snappingOffsetInPixel: number = 0;

    constructor(parent: ValueChangerController, p_minValue: number, p_maxValue: number, sliderAndBarContainer: ISliderValueDisp, snapping: number = 0) {
        super(parent, p_minValue, p_maxValue);
        this.sliderContainer = sliderAndBarContainer;
        this._barOffset = (this.sliderContainer.getSlider().width - 1) / 2;
        this._barSize = this.sliderContainer.getSliderBar().width - 2 * this._barOffset;
        this.sliderContainer.getSlider().addEventListener("mousedown", this.bindFunction(this.mouseDown));
        this.snappingOffsetInPixel = snapping;
        this.isDisposed = false;
    }

    private mouseUp(event: MouseEvent): void {
        this.sliding = false;
        this.sliderContainer.getSlider().stage.removeEventListener("mousemove", this.bindFunction(this.mouseMove));
        this.sliderContainer.getSlider().stage.removeEventListener("pressup", this.bindFunction(this.mouseUp));
    }

    private mouseMove(event: MouseEvent): void {
        // TODO: @HTML5
        /*let sliderX: number = this.sliderContainer.getSlider().x;
        let wasPosValueSet: boolean = false;
        let posValue: number;

        if (this.sliderContainer.getSliderBar().mouseX < this._barOffset + this.snappingOffsetInPixel) {
            posValue = this.minValue;
            wasPosValueSet = true;
        }
        else if (this.sliderContainer.getSliderBar().mouseX > this._barSize + this.sliderContainer.getSliderBar().x - this.snappingOffsetInPixel) {
            posValue = this.maxValue;
            wasPosValueSet = true;
        }
        else {
            sliderX = this.sliderContainer.getSliderBar().mouseX + this._barOffset;
        }

        if (!wasPosValueSet) {
            posValue = Math.round(this.minValue + ((((sliderX - this._barOffset - this.sliderContainer.getSliderBar().x) / this._barSize)) * (this.maxValue - this.minValue)));
        }

        if (posValue != this.value) {
            this.dispatchUpdateByUserSignal(posValue);
        }*/
    }

    private mouseDown(event: MouseEvent): void {
        this.sliding = true;
        this.sliderContainer.getSlider().stage.addEventListener("mousemove", this.bindFunction(this.mouseMove));
        this.sliderContainer.getSlider().stage.addEventListener("pressup", this.bindFunction(this.mouseUp));
    }

    public updateValue(value: number): void {
        super.updateValue(value);

        let posInPercent: number = (value - this.minValue) / (this.maxValue - this.minValue);

        if (this.sliderContainer.getFilledBar()) {
            this.sliderContainer.getFilledBar().width = (posInPercent * this._barSize) + this._barOffset + this.sliderContainer.getSliderBar().x;
        }

        /*if(!sliding)
         {*/
        this.sliderContainer.getSlider().x = (posInPercent * this._barSize) + this.sliderContainer.getSlider().x + this._barOffset;
        //}
    }

    public dispose(): void {
        if (!this.isDisposed) {
            this.sliderContainer.getSlider().removeEventListener("mousedown", this.bindFunction(this.mouseDown));
            this.sliderContainer.getSlider().stage.removeEventListener("mousemove", this.bindFunction(this.mouseMove));
            this.sliderContainer.getSlider().stage.removeEventListener("pressup", this.bindFunction(this.mouseUp));
        }
        super.dispose();
    }
}
